export const WPNType = () => import("./List.vue");
export const WpnTypeCreate = () => import("./Create.vue");
export const WpnTypeEdit = () => import("./Edit.vue");
